import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../../common/types';
import { BillingInterval } from '../../../config/music24StripePlans';
import styles from './BillingToggle.module.scss';

export interface BillingToggleProps {
  interval: BillingInterval;
  onChange: (interval: BillingInterval) => void;
  className?: string;
}

const BillingToggleComponent: React.FC<BillingToggleProps> = ({ interval, onChange, className }) => {
  const intl = useIntl();
  const yearly = interval === 'yearly';

  return (
    <div className={clsx(styles.bill, className)}>
      <div
        className={styles.segToggle}
        role="radiogroup"
        aria-label={intl.formatMessage({ id: 'app.sml.pricing.toggle.label', defaultMessage: 'Billing period' })}
      >
        <div className={clsx(styles.thumb, yearly && styles.thumbYearly)} />
        <button
          type="button"
          role="radio"
          aria-checked={!yearly}
          className={clsx(!yearly && styles.on)}
          onClick={() => onChange('monthly')}
        >
          {intl.formatMessage({ id: 'app.sml.pricing.toggle.monthly', defaultMessage: 'Monthly' })}
        </button>
        <button
          type="button"
          role="radio"
          aria-checked={yearly}
          className={clsx(yearly && styles.on)}
          onClick={() => onChange('yearly')}
        >
          {intl.formatMessage({ id: 'app.sml.pricing.toggle.yearly', defaultMessage: 'Yearly' })}
        </button>
      </div>
      <span className={styles.save}>
        <span className={styles.sd} />
        {intl.formatMessage({ id: 'app.sml.pricing.toggle.twoMonthsFree', defaultMessage: '2 months free' })}
      </span>
    </div>
  );
};

export const BillingToggle = TypedMemo(BillingToggleComponent);
